// src/App.jsx
import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
} from "react-router-dom";

// Components
import Header from "./components/home/Header/Header";
import HeaderBottom from "./components/home/Header/HeaderBottom";
import SpecialCase from "./components/SpecialCase/SpecialCase";
import Footer from "./components/home/Footer/Footer";
import FooterBottom from "./components/home/Footer/FooterBottom";

// Pages
import Home from "./pages/Home/Home";
import Shop from "./pages/Shop/Shop";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import ContactPage from "./pages/ContactPage";
import Journal from "./pages/Journal/Journal";
import Offer from "./pages/Offer/Offer";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Cart from "./pages/Cart/Cart";
import Payment from "./pages/payment/Payment";
import SignIn from "./pages/Account/SignIn";
import SignUp from "./pages/Account/SignUp";

// Category Pages
import GroceryPage from "./pages/GroceryPage";
import FruitsPage from "./pages/FruitsPage";
import HomeAppliancesPage from "./pages/HomeAppliancesPage";
import BagsPage from "./pages/Bagspages"; // ✅ Updated to match file name

// Layout component with header/footer
const Layout = () => {
  return (
    <>
      <Header />
      <HeaderBottom />
      <SpecialCase />
      <ScrollRestoration />
      <Outlet />
      <Footer />
      <FooterBottom />
    </>
  );
};

// Router configuration
const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Main layout routes */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="shop" element={<Shop />} />

        {/* Category Pages */}
        <Route path="grocery" element={<GroceryPage />} />
        <Route path="fruits" element={<FruitsPage />} />
        <Route path="homeappliances" element={<HomeAppliancesPage />} />
        <Route path="bags" element={<BagsPage />} /> {/* ✅ Bags page */}

        {/* Other Pages */}
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="contact-page" element={<ContactPage />} />
        <Route path="journal" element={<Journal />} />
        <Route path="offer" element={<Offer />} />
        <Route path="product/:_id" element={<ProductDetails />} />
        <Route path="cart" element={<Cart />} />
        <Route path="paymentgateway" element={<Payment />} />
      </Route>

      {/* Auth routes */}
      <Route path="signup" element={<SignUp />} />
      <Route path="signin" element={<SignIn />} />
    </>
  )
);

function App() {
  return (
    <div className="font-bodyFont">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
